// @flow

// https://github.com/diegohaz/arc/wiki/Reducers
import { combineReducers } from 'redux'
import { reducer as form } from 'redux-form'
import { i18nReducer } from 'redux-react-i18n'
import commonReducer from './common.reducer'
import meetingAndSymposiaReducer from './redux/meetingAndSymposia'
import eventSearchReducer from './redux/eventsSearch'
import myScheduleReducer from 'redux/mySchedule'

// App initial state
const reducers = {
	i18nReducer,
	form,
	commonReducer,
	meetingAndSymposia: meetingAndSymposiaReducer,
	eventSearch: eventSearchReducer,
	mySchedule: myScheduleReducer
}

export default combineReducers(reducers)
